import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import './src/styles/print.css'; // Import print styles for PDF export

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: import.meta.env.PROD,
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Could not find root element to mount to');
}

function ErrorFallback({ error, resetError }: { error: Error; resetError: () => void }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '2rem',
        textAlign: 'center',
        fontFamily: 'sans-serif',
        background: '#0f172a',
        color: '#f1f5f9',
      }}
    >
      <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Une erreur est survenue</h1>
      <p style={{ color: '#94a3b8', marginBottom: '1.5rem' }}>
        Notre équipe a été notifiée automatiquement. Essayez de recharger la page.
      </p>
      <button
        onClick={resetError}
        style={{
          padding: '0.6rem 1.5rem',
          borderRadius: '8px',
          border: 'none',
          background: '#6366f1',
          color: 'white',
          cursor: 'pointer',
          fontSize: '1rem',
        }}
      >
        Recharger
      </button>
    </div>
  );
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <ErrorFallback error={error as Error} resetError={resetError} />
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
